import { type Filter } from '../types/filters.interfaces';
import { type StepValue } from '../types/wizard.interfaces';

export function stepValuesToFilters(values: StepValue[]): Filter[] {
  const filters: Filter[] = [];
  for (const val of values) {
    filters.push({ id: val.id, name: val.value, group: val.group });
    if (val.isParent && val.values) {
      for (const child of val.values) {
        filters.push({ id: child.id, name: child.value, group: child.group });
      }
    }
  }
  return filters;
}
